import { GridColDef } from "@mui/x-data-grid-pro";
import { GKButton, GKClientDataGrid, GKModal, Grid2 } from "components";
import { EquitybasketFormInterface } from "interfaces/EquityBasket";
import { Controller, useFormContext } from "react-hook-form";
import { useAppSelector } from "store/store";
import { GKModalProps } from "utils/commonInterface";
import { extraColumnsField } from "utils/helpers";

const AddBasketPartner = ({ open, setOpen }: GKModalProps) => {
  const form = useFormContext<EquitybasketFormInterface>();

  const partnerList = useAppSelector((state) => state?.app?.partnerList);

  const columns: GridColDef[] = [
    {
      ...extraColumnsField("Name", "name", 150, 1),
    },
    {
      ...extraColumnsField("Code", "code", 150, 1),
    },
    {
      ...extraColumnsField("Email", "email", 150, 1),
    },
    {
      ...extraColumnsField("Phone", "phone", 150, 1),
    },
    {
      ...extraColumnsField("Branch", "headBranch", 150, 1),
    },
  ];

  return (
    <GKModal
      open={open}
      setOpen={setOpen}
      modalTitle="Edit Partner "
      width={"60%"}
      footer={
        <GKButton
          variant="contained"
          onClick={() => {
            setOpen(false);
          }}
        >
          Save
        </GKButton>
      }
    >
      <Grid2 container>
        <Grid2 size={12}>
          <Controller
            name="partners"
            control={form.control}
            render={({ field }) => {
              return (
                <GKClientDataGrid
                  checkboxSelection
                  rows={partnerList || []}
                  columns={columns}
                  maxHeight={"calc(100vh - 312px)"}
                  name="basketPartner"
                  columnsButton={false}
                  density="compact"
                  rowSelectionModel={field.value}
                  disableRowSelectionOnClick
                  onRowSelectionModelChange={(params) => field.onChange(params)}
                />
              );
            }}
          />
        </Grid2>
      </Grid2>
    </GKModal>
  );
};

export default AddBasketPartner;
